<template>
  <Modal>
    <Modal.Title>Cancel plan</Modal.Title>
    <Modal.Body>
      <CancelPlanBody />
    </Modal.Body>
    <Modal.Footer layout="vertical">
      <Button variant="danger" @click="handleConfirm"
        >Cancel subscription</Button
      >
      <Button variant="stroke" @click="close()">Keep subscription</Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'

import { openModal, Modals } from '@/shared/dialogs/modals'
import CancelPlanBody from './CancelPlanBody.vue'

const { close } = useModal()

const handleConfirm = () => {
  openModal(Modals.ConfirmCancelPlan)
}
</script>
